import React from "react";
import { cn } from "@/lib/utils";

interface SectionHeaderProps {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  description: string;
  action?: React.ReactNode;
  className?: string;
}

export function SectionHeader({
  icon: Icon,
  title,
  description,
  action,
  className,
}: SectionHeaderProps) {
  return (
    <div className={cn("space-y-3", className)}>
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
            <Icon className="h-5 w-5 text-primary" />
          </div>
          <h2 className="text-xl font-semibold text-[var(--foreground)]">
            {title}
          </h2>
        </div>
        {action && <div>{action}</div>}
      </div>
      <p className="text-sm text-muted-foreground max-w-4xl leading-relaxed">
        {description}
      </p>
    </div>
  );
}